import { render, staticRenderFns } from "./Regularization.vue?vue&type=template&id=39166fbc"
import script from "./Regularization.vue?vue&type=script&lang=js"
export * from "./Regularization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports